// API Configuration
// Always use relative /api path - works on both preview and production
// Kubernetes ingress routes /api/* to the backend on all environments

export const API = '/api';

export default API;
